import React from 'react'

const OrderPrint = ({ values, currencyDetail, distributorList }) => {

    const HandleOpenPDFSummary = (item) => {
        const url = `/pdf-factory-order-summary?id=${item?.id}&orderId=${item?.orderId || ""}`;
        window.open(url, "_blank", "noopener,noreferrer");
    };


    const HandleOpenPDFDetail = (item) => {
        const url = `/pdf-factory-order-detail?id=${item?.id}&orderId=${item?.orderId || ""}`;
        window.open(url, "_blank", "noopener,noreferrer");
    }

    return (
        <>
            <div className="text-right">
                <div className="dropdown">
                    <button
                        className="btn print-btn"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        Print <i class="fas fa-chevron-down ml-2"></i>
                    </button>
                    <div
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                    >
                        <ul>
                            <li onClick={(e) => {
                                e.preventDefault();
                                HandleOpenPDFSummary(values);
                            }}>
                                <span>
                                    Preview Summary
                                </span>
                            </li>
                            <li onClick={(e) => {
                                e.preventDefault();
                                HandleOpenPDFDetail(values);
                            }}>
                                <span>Preview Detail
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}

export default OrderPrint
